import { Text, TextProps } from '@chakra-ui/react';

import { TransactionDirection } from '@aslanpay/portal-common-lib';

import { formatCurrency } from 'app/utils/strings';

interface CurrencyAmountProps extends Omit<TextProps, 'children'> {
  amount: number;
  currency?: string;
  direction?: TransactionDirection | 'DEBIT' | 'CREDIT';
  showSign?: boolean;
}

function CurrencyAmount({
  amount,
  currency = '',
  direction = undefined,
  showSign = false,
  ...textProps
}: CurrencyAmountProps) {
  const getSign = () => {
    if (!showSign || !direction) return '';
    return direction === 'DEBIT' ? '- ' : '+ ';
  };

  const displayAmount = showSign ? Math.abs(amount) : amount;
  const formattedAmount = currency
    ? formatCurrency(displayAmount, currency)
    : displayAmount.toFixed(2);

  return (
    <Text fontFamily="mono" {...textProps}>
      {getSign()}
      {formattedAmount}
    </Text>
  );
}

export default CurrencyAmount;
